<template>
  <div class="">
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-bottom">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/icon-words.svg" width="50" alt="Minds">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">
        <h2 class="animation-top animation-delay-02">MY <span>GOALS</span></h2>
        <hr class="header-text-hr animation-top animation-delay-02">
        <p class="animation-bottom animation-delay-04">Ajuste suas metas, para chegar até a excelência no inglês.</p>
      </div>
    </div>
    <div class="box-content shadow-box box-content-border hidden min-height container justify-content-center align-items-center">

      <div class="box--item animation-bottom animation-delay-05">
        <h4>COMING SOON</h4>
      </div>

    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    components: {
    },
    data () {
      return {
        form: {
          name: '',
          mail: '',
          region: '',
          resource: ''
        }
      }
    },
    methods: {
      onSubmit () {
        console.log('submit!')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/goals/index.vue